import {
  ClickAwayListener,
  IconButton,
  makeStyles,
  Theme,
} from '@material-ui/core'
import classNames from 'classnames'
import { CustomPopper } from 'components/Popper/CustomPopper'
import { bomItemHasComment } from 'features/BillOfMaterials/store/selectors/bomItemCommentSelector'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useState } from 'react'
import { useAppSelector } from 'store/configureStore'
import { ReactComponent as MessageOff } from '_icons/message_off_mini.svg'
import { ReactComponent as MessageOn } from '_icons/message_on_mini.svg'
import { CommentForm } from './CommentForm'

const useStyle = makeStyles((theme: Theme) => ({
  icon: {
    width: '1em',
    height: '1em',
    fontSize: '1.5rem',
    // fill: 'currentColor',
  },
  pinned: {
    backgroundColor: `${theme.palette.action.selected} !important`,
  },
}))

export function CommentTooltip(props: {
  bomItemId: string
  bomItemType: BoMItemType
  tooltipClass?: string
  showBadge?: boolean
  useTooltipPortal?: boolean
}) {
  const classes = useStyle()

  const hasComment = useAppSelector(bomItemHasComment(props.bomItemId))

  const [pinned, setPinned] = useState(undefined)

  const switchPinnedState = () => {
    setPinned((open) => (open ? false : true))
  }

  return (
    <CustomPopper
      usePortal={props.useTooltipPortal}
      TooltipComponent={
        <ClickAwayListener onClickAway={switchPinnedState}>
          <span>
            <CommentForm bomItemId={props.bomItemId} />
          </span>
        </ClickAwayListener>
      }
      isOpen={pinned}
      AnchorComponent={
        <IconButton
          size="small"
          onDoubleClick={switchPinnedState}
          className={classNames({ [classes.pinned]: pinned })}
          disableRipple
          disableFocusRipple
          disableTouchRipple
        >
          {hasComment ? (
            <MessageOn className={classes.icon} />
          ) : (
            <MessageOff className={classes.icon} />
          )}
        </IconButton>
      }
    />
  )
}
